export default (stringVar) => {
  console.log(stringVar);
}